module.exports = __webpack_public_path__ + "static/media/customstore-desktop.e0794114.webp";